import {SET_CURRENT_USER} from './types';
import jwt_decode from 'jwt-decode';
import Cookies from 'js-cookie';
import axios from 'axios';
import Log from '../utils/Log';

export const loginFacebook = () => dispatch => {
  const token = Cookies.get('auth');
  Log.trace('Login Successful');
  const decoded = jwt_decode(token);
  dispatch(setCurrentUser(decoded));
};

export const setCurrentUser = (decoded) => {
  return {
    type:  SET_CURRENT_USER,
    payload: decoded,
  };
};

export const logoutUser = () => dispatch => {
  axios
    .get('/api/users/logout')
    .then(response => {
      Log.trace('Logout');
      Log.trace(response);
      Cookies.remove('auth');
      dispatch(setCurrentUser({}));
      window.location.href = '/';
    });
  // setAuthToken(false);
  // Cookies.remove('auth');
  // dispatch(setCurrentUser({}));
  // window.location.href = '/';
};
